import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignKeywordsSchema, campaignTrackItemSchema } from '../schema';

export const updateCampaignDetailRequestSchema = z.object({
  start_date: z.string().trim().min(1),
  end_date: z.string().trim().min(1).nullable().optional(), // null 인 경우 end_date 미설정 (해제)
  items: z.array(campaignTrackItemSchema),
  ...campaignKeywordsSchema.shape,
});

export type UpdateCampaignDetailRequest = z.infer<typeof updateCampaignDetailRequestSchema>;

export async function UpdateCampaignDetail(
  campaignId: string,
  request: UpdateCampaignDetailRequest,
  signal?: AbortSignal,
): Promise<void> {
  const parsedRequest = updateCampaignDetailRequestSchema.parse(request);
  const response = await socialApiClient.patch(`campaigns/${campaignId}`, {
    json: parsedRequest,
    signal,
  });
  await response.json();
}
